import React, { useEffect, useState } from "react";

import moment from "moment";
import { AxiosError } from "axios";
import { useNavigate } from "react-router";
import {
  Button,
  Card,
  Checkbox,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
} from "antd";

import { BotType } from "types/bot-types";
import { PlusOutlined } from "@ant-design/icons";
import { PlatformType } from "types/platform-types";
import { get, remove } from "services/platform.service";

import styles from "./style.module.scss";

const PlatformList: React.FC = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "10%",
    },
    {
      title: "Auto Add Agent",
      dataIndex: "isAutoAddAgent",
      key: "isAutoAddAgent",
      width: "10%",
      align: "center" as const,
      render: (isAutoAddAgent: boolean) => (
        <Checkbox
          checked={isAutoAddAgent}
          className={styles.checkboxCursorDefault}
        />
      ),
    },
    {
      title: "Created At",
      key: "created",
      dataIndex: "created",
      width: "10%",
      render: (created: Date) => moment(created).format("DD/MM/yyyy HH:mm:ss"),
    },
    {
      title: "Last Modified",
      key: "lastModifiedDate",
      dataIndex: "lastModifiedDate",
      width: "10%",
      render: (lastModifiedDate: Date) =>
        moment(lastModifiedDate).format("DD/MM/yyyy HH:mm:ss"),
    },
    {
      title: "Action",
      render: (record: BotType) => (
        <Space>
          <Button onClick={() => navigate(`/platform/edit/${record.code}`)}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure to delete this platform?"
            onConfirm={() => callRemove(record.code)}
            okText="Yes"
            cancelText="No"
            placement="leftTop"
          >
            <Button danger>Remove</Button>
          </Popconfirm>
        </Space>
      ),
      width: "10%",
    },
  ];

  const [data, setData] = useState<PlatformType[]>([]);

  useEffect(() => {
    callGetList();
  }, []);

  const callGetList = async () => {
    const platforms = await get({});
    setData(platforms);
  };

  const callRemove = async (code: string) => {
    try {
      await remove(code);
      message.success("Platform is removed");
      callGetList();
    } catch (ex: AxiosError | unknown) {
      if (ex instanceof AxiosError) {
        message.error(ex.response?.data?.message);
      } else {
        message.error("Remove failed");
      }
    }
  };

  return (
    <>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <Card bordered={false} className="criclebox">
              <div>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => navigate("/platform/create")}
                >
                  Create
                </Button>
              </div>
              <div className="table-responsive">
                <Table
                  rowKey={"code"}
                  columns={columns}
                  dataSource={data}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PlatformList;
